import React from 'react';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import IconButton from "@material-ui/core/IconButton";
import {makeStyles} from "@material-ui/core";
import usePersistentStore from "../../../persistentStore";
import useLayoutStore from "../../../layoutStore";

const useStyles = makeStyles(theme => ({
    hideTabLabels: {
        position: 'absolute',
        left: -2,
        fontSize: 16
    },
    showTabLabels: {
        position: 'absolute',
        left: -2,
        fontSize: 16
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        position: 'relative',
    }
}));

const ToggleLabels = props => {
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [globalLayoutState] = useLayoutStore();

    const classes = useStyles();

    return (
        <IconButton aria-label="showLabels"
                    className={globalPersistentState.showEditTabLabels ? classes.showTabLabels : classes.hideTabLabels}
                    size="small"
                    style={{top: globalLayoutState.editTabBarHeight - 18}}
                    color="inherit"
                    onClick={() => {
                        globalPersistentActions.setShowEditTabLabels(!globalPersistentState.showEditTabLabels);
                    }}>
            {globalPersistentState.showEditTabLabels && <VisibilityOffOutlinedIcon fontSize="inherit"/>}
            {!globalPersistentState.showEditTabLabels && <VisibilityOutlinedIcon fontSize="inherit"/>}
        </IconButton>
    );
};

export default ToggleLabels;
